import React, { useState } from 'react';
import './styles.css'
import {
    Container,
    Box,
    Typography,
} from "@mui/material";
import Media from 'react-media';
import Image from '../../images/Header.svg';
import { addContact } from '../../../../api'


const Header = () => {

  const [isFormOpen, setIsformOpen] = useState(false)

  const [ formData, setFormData ] = useState({
    name: "",
    contactNo: "",
    email: "",
    message: ""
  })

  const handleChange = (event)=>{
    const { name, value } = event.target
    setFormData(prevFormData => {
        return {
            ...prevFormData,
            [name]: value
        }
    })
  }

  const handleSubmit = async (event)=>{
    event.preventDefault()
    const response = await addContact(formData);
    console.log(response);
    setFormData({
      name: "",
      contactNo: "",
      email: "",
      message: ""
    })
  }
  return (
  <>
    <div>
      <div className="home__hire">
        <div className={`header__contact ${isFormOpen? 'header__contact--open':''}`}>
          <form onSubmit={handleSubmit} className="contact__form header__contact__form">
            <p onClick={()=>setIsformOpen(!isFormOpen)} className="header__contact__text">Quick Contact</p>
            <input type="text" className="form__input" name="name" placeholder="Name" onChange={handleChange} value={formData.name}/>
            <input type="text" className="form__input" name="contactNo" placeholder="Contact Number" onChange={handleChange} value={formData.contactNo}/>
            <input type="text" className="form__input" name="email" placeholder="E-Mail" onChange={handleChange} value={formData.email}/>
            <textarea name="message" className="form__textarea" placeholder="Message" onChange={handleChange} value={formData.message}/>
            <button className="submitbtn">SUBMIT</button>
          </form>
        </div>
      </div>
    </div>
  </>
  )
}

export default Header
